<mat-tab-group mat-align-tabs="center" class="full-width" (selectedTabChange)="tabHasChanged($event)">
  <mat-tab label="Connaître tous les CAC">
  	<pannel [title]="'Filtres'" [expandable]="true" [folded]="true">
		<consultation-perimetre-filters (filterRequest)="filters$.next($event)" ></consultation-perimetre-filters>
	</pannel>
	<pannel [title]="'Chargés d\'Accès et de Conduite de toutes les agences'">
		<responsabilite-grid [refreshCommands]="refreshCacCommand" [responsabilite]="typeResponsabiliteCac" [filtersSubject]="filters$" ></responsabilite-grid>
	</pannel>
  </mat-tab>
  <mat-tab label="Connaître tous les CC">
  	<pannel [title]="'Filtres'" [expandable]="true" [folded]="true">
		<consultation-perimetre-filters (filterRequest)="filters$.next($event)" ></consultation-perimetre-filters>
	</pannel>
	<pannel [title]="'Chargés d\'Accès et de Conduite de toutes les agences'">
		<responsabilite-grid [refreshCommands]="refreshCcCommand" [responsabilite]="typeResponsabiliteCc" [filtersSubject]="filters$" ></responsabilite-grid>
	</pannel>
  </mat-tab>
</mat-tab-group>